module.exports = __webpack_public_path__ + "img/wallet (6).2aee7ce4.svg";